export default {
  SET_AUTH_DATA (state, data) {
    state.authData = data
    localStorage.setItem('auth-data', JSON.stringify(data))
  },
  CLEAR_AUTH_DATA (state, redirect = false) {
    localStorage.removeItem('auth-data')
    if (redirect) {
      location.href = '/'
    }
    // location.reload()
  },
  CLEAR_LOCAL_STORAGE_DATA  (state) {
    const newopportunityKeys = Object.keys(localStorage).filter(item => item.indexOf('newopportunity/') > -1)
    const editCitiesKeys = Object.keys(localStorage).filter(item => item.indexOf('edit/cities/') > -1)

    if (newopportunityKeys.length > 0) {
      newopportunityKeys.forEach(item => localStorage.removeItem(String(item)))
    }
    if (editCitiesKeys.length > 0) {
      editCitiesKeys.forEach(item => localStorage.removeItem(String(item)))
    }

    localStorage.removeItem('edit/countries')
  }
}
